// สถานะอัปเดต PWA — registerServiceWorker.js commit เข้ามาเมื่อมี SW เวอร์ชันใหม่รออยู่
const state = {
    updateAvailable: false,
}

const getters = {}

const mutations = {
    SET_UPDATE_AVAILABLE(state, value) {
        state.updateAvailable = value
    },
}

const actions = {}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
